module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "编号"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getLists.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.scode),
      callback: function($$v) {
        _vm.$set(_vm.filters, "scode", $$v)
      },
      expression: "filters.scode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "名称"
    },
    nativeOn: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getLists.apply(null, arguments)
      }
    },
    model: {
      value: (_vm.filters.sname),
      callback: function($$v) {
        _vm.$set(_vm.filters, "sname", $$v)
      },
      expression: "filters.sname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary",
      "icon": "el-icon-search"
    },
    on: {
      "click": _vm.getLists
    }
  }, [_vm._v("搜索")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "90%"
    },
    attrs: {
      "data": _vm.datalist,
      "border": "",
      "stripe": "",
      "highlight-current-row": "",
      "height": "600"
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "entime",
      "label": "时间",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "scode",
      "label": "编号",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "alisna",
      "label": "别名",
      "min-width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sname",
      "label": "名称",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "label": "备注",
      "min-width": "100"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "fixed": "right",
      "width": "100"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('div', [_c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleEdit(scope.$index, scope.row)
            }
          }
        }, [_vm._v("编辑")]), _vm._v(" "), _c('el-button', {
          attrs: {
            "type": "text",
            "size": "small"
          },
          on: {
            "click": function($event) {
              return _vm.handleDel(scope.$index, scope.row)
            }
          }
        }, [_vm._v("删除")])], 1)]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "total,prev, pager, next",
      "page-size": _vm.pagesize,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": _vm.editformtitle,
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "100px",
      "rules": _vm.formRules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "编号",
      "prop": "scode"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "编号"
    },
    model: {
      value: (_vm.editForm.scode),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "scode", $$v)
      },
      expression: "editForm.scode"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "名称",
      "prop": "sname"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "名称"
    },
    model: {
      value: (_vm.editForm.sname),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "sname", $$v)
      },
      expression: "editForm.sname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "别名",
      "prop": "alisna"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "别名"
    },
    model: {
      value: (_vm.editForm.alisna),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "alisna", $$v)
      },
      expression: "editForm.alisna"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "处理类",
      "prop": "process_class"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "处理类"
    },
    model: {
      value: (_vm.editForm.process_class),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "process_class", $$v)
      },
      expression: "editForm.process_class"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    staticClass: "is-required",
    attrs: {
      "label": "拉取数据状态"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择状态"
    },
    model: {
      value: (_vm.editForm.valid),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "valid", $$v)
      },
      expression: "editForm.valid"
    }
  }, [_c('el-option', {
    attrs: {
      "label": "有效",
      "value": "1"
    }
  }), _vm._v(" "), _c('el-option', {
    attrs: {
      "label": "无效",
      "value": "0"
    }
  })], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注",
      "prop": "remark"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "备注",
      "type": "textarea",
      "row": 15
    },
    model: {
      value: (_vm.editForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "remark", $$v)
      },
      expression: "editForm.remark"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "token",
      "prop": "tokenstr"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "token",
      "type": "textarea",
      "row": 15
    },
    model: {
      value: (_vm.editForm.tokenstr),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "tokenstr", $$v)
      },
      expression: "editForm.tokenstr"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit.apply(null, arguments)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-f18c13da"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/views/adx/spInfo.vue
// module id = 665
// module chunks = 1